import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Preview from './views/Preview.vue'
import Page from './components/Page'
import ArticlePage from './components/ArticlePage'
import Meta from 'vue-meta'

Vue.use Router
Vue.use Meta

export default new Router
    mode: 'history',
    scrollBehavior: -> 
        x: 0
        y: 0
    ,
    routes: [
        path: '/index.html',
        redirect: '/'
    ,
        path: '/',
        component: Page
    , 
        path: '/not-found',
        name: 'not-found',
        component: NotFound
    , 
        path: '/preview',
        name: 'preview',
        component: Preview
    , 
        path: '/artikel/:uid',
        name: 'article',
        component: ArticlePage
    , 
        path: '/:uid',
        name: 'content',
        component: Page
    , 
        path: '*',
        name: 'not-found',
    ]
